<template>
  <span class="pricing-table-hint">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <g v-if="icon === 'info'">
        <circle cx="8" cy="8" r="8" fill="#eaeaea" />
        <path
          fill="#505050"
          d="M8.25523 4.18457c.561 0 1.0285.08617 1.4025.2585.37397.16867.65447.39417.84147.6765.1907.27867.286.58117.286.9075 0 .35567-.0696.64717-.209.8745-.1356.22367-.3043.4125-.506.5665-.20163.15033-.40513.2915-.61047.4235-.20166.132-.37216.2805-.5115.4455-.13566.165-.2035.37583-.2035.6325v.2255h-1.5895v-.2805c0-.37767.0605-.68567.1815-.924.12467-.242.27684-.44.4565-.594.18334-.154.36484-.28783.5445-.4015.17967-.11733.33-.2365.451-.3575.12467-.12467.187-.27867.187-.462 0-.20167-.0825-.35567-.2475-.462-.165-.10633-.37583-.1595-.6325-.1595-.24933 0-.49316.055-.7315.165-.23466.11-.451.27867-.649.506l-1.1-.858c.31534-.37033.68934-.66 1.122-.869.43634-.209.94234-.3135 1.518-.3135Zm-.286 6.01153c.275 0 .50967.099.704.297.19434.1943.2915.4271.2915.6985 0 .2713-.09716.506-.2915.704-.19433.1943-.429.2915-.704.2915-.27866 0-.51333-.0972-.704-.2915-.19066-.198-.286-.4327-.286-.704 0-.2714.09534-.5042.286-.6985.19067-.198.42534-.297.704-.297Z"
        />
      </g>
      <g v-if="icon === 'rub'">
        <rect width="16" height="16" fill="#505050" rx="2" />
        <path
          fill="#fff"
          d="M7.25011 7.952V5.268h1.067c.924 0 1.485.363 1.485 1.298v.044c0 .869-.517 1.342-1.485 1.342h-1.067Zm2.508 2.442V9.69h-2.508v-.671h1.1c1.67199 0 2.87099-.748 2.87099-2.409v-.044c0-1.65-1.144-2.431-2.90399-2.431h-2.541V8.26h-1.078v.693h1.078v.737h-1.078v.704h1.078V12h1.474v-1.606h2.508Z"
        />
      </g>
      <g v-if="icon === 'kzt'">
        <rect width="16" height="16" fill="#505050" rx="2" />
        <path
          fill="#fff"
          d="M10.8811 4.828v-.693H5.11705v.693h5.76405ZM7.26205 12h1.474V6.72h2.14505V5.565H5.11705V6.72h2.145V12Z"
        />
      </g>
      <g v-if="icon === 'uzs'">
        <rect width="16" height="16" fill="#505050" rx="2" />
        <path
          stroke="#fff"
          stroke-linecap="square"
          stroke-miterlimit="10"
          stroke-width="1.6"
          d="M4.57591 3.86673s0 .47054-.02099 3.83284c-.02099 3.36233.89751 4.55313 3.32034 4.55313 3.16274 0 3.55654-1.1507 3.57024-2.50384.0136-1.35312-1.56934-1.79752-2.76027-2.18279-1.19093-.38526-1.94829-1.35111-1.50181-2.61219.44649-1.26107 2.17153-1.42741 3.74538-.98428"
        />
      </g>
      <g v-if="icon === 'usd'">
        <rect width="16" height="16" fill="#505050" rx="2" />
        <path
          fill="#fff"
          d="M6.47779 6.159c0-.55.418-.979 1.177-1.067v2.167c-.968-.198-1.177-.528-1.177-1.1Zm3.135 3.652c0 .649-.484 1.111-1.221 1.21V8.667c.957.209 1.221.517 1.221 1.144Zm-1.958 3.674h.737v-1.386c1.61701-.11 2.57401-1.133 2.57401-2.42 0-1.485-.946-2.035-2.57401-2.299V5.125c.671.11 1.012.495 1.133 1.166h1.29801c-.132-1.364-1.01201-2.101-2.43101-2.233V3.057h-.737v.99c-1.496.099-2.475 1.012-2.475 2.233 0 1.397.847 1.991 2.475 2.266v2.475c-1.045-.132-1.287-.737-1.375-1.452h-1.364c.11 1.331.858 2.398 2.739 2.53v1.386Z"
        />
      </g>
      <g v-if="icon === 'eur'">
        <rect width="16" height="16" fill="#505050" rx="2" />
        <path
          fill="#fff"
          d="M4.49989 7.721h.726v.748h-.726v.693h.759c.22 1.727 1.309 2.948 3.124 2.948 1.72701 0 2.78301-1.012 2.98101-2.75H9.99989c-.14299 1.056-.682 1.595-1.595 1.595-1.012 0-1.562-.66-1.705-1.793h1.87l.121-.693h-2.024v-.748h2.167l.132-.693h-2.266c.143-1.144.693-1.87 1.694-1.87.847 0 1.397.517 1.518 1.452h1.37501c-.176-1.661-1.232-2.585-2.89301-2.585-1.793 0-2.915 1.287-3.135 3.003h-.759v.693Z"
        />
      </g>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'VPricingTableHint',
  props: {
    icon: {
      type: String,
      default: 'info',
    },
  },
};
</script>
